<template>
<div>
    <breadcrumbs>
		<router-link to="/">Mis cursos</router-link>
        <span v-if="course">{{ course.title }}</span>
	</breadcrumbs>
    <div v-if="course">
        <course-detail :course="course"></course-detail>
        <section class="course-section spad pt-0 pb-5">
            <div class="course-warp">
                <ul class="course-filter controls">
                    <li v-for="cat in lessonCats" :key="cat.id" class="control" :class="{'mixitup-control-active': lessonCat == cat.id}" @click="lessonCat = cat.id">{{ cat.name }}</li>
                </ul>
                <div class="row course-items-area" v-if="lessonCat == 0">
                    <lesson-card v-for="lesson in course.lections" :key="lesson.id" :lesson="lesson"></lesson-card>
                </div>
                <div class="row course-items-area" v-else-if="lessonCat == 1">
                    <lesson-card v-for="lesson in completedLessons" :key="lesson.id" :lesson="lesson"></lesson-card>
                    <h6 v-if="completedLessons.length == 0" class="w-100 text-center ml-3 mr-3 mb-4">¡Vaya! Parece que aún no has completado ninguna lección de este curso. ¿Por qué no comienzas ahora?</h6>
                </div>
                <div class="row course-items-area" v-else-if="lessonCat == 2">
                    <lesson-card v-for="lesson in uncompletedLessons" :key="lesson.id" :lesson="lesson"></lesson-card>
                    <h6 v-if="uncompletedLessons.length == 0" class="w-100 text-center ml-3 mr-3 mb-4">¡Enhorabuena, has completado todas las lecciones de este curso!</h6>
                </div>
            </div>	
        </section>
    </div>
    <div class="loader-container pt-5" v-else>
		<div class="loader mt-0 mb-0"></div>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config.js'

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import CourseDetail from '@/components/CourseDetail.vue'
import LessonCard from '@/components/LessonCard.vue'

export default {
    name: 'course',
    components: {
        Breadcrumbs,
        CourseDetail,
        LessonCard
    },
    data() {
        return {
            course: null,
            lessonCat: 0,
            lessonCats: [
                {
                    id: 0,
                    name: 'Todas las lecciones'
                },
                {
                    id: 1,
                    name: 'Completadas'
                },
                {
                    id: 2,
                    name: 'Pendientes'
                }
            ]
        }
    },
    created() {
        if (this.$store.getters.course && this.$store.getters.course.id == this.$route.params.id) {
            this.course = this.$store.getters.course;
        } else {
            this.getCourse();
        }
    },
    methods: {
        getCourse() {
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.user.token
                }
            }
            axios.get(`${API_URL}/private/user/courses/${this.$route.params.id}`, config)
				.then(response => {
                    if (response.status == 200) {
                        this.course = response.data;
                        this.$store.commit('setCourse', response.data);
                    } else {
                        this.$router.push('/');
                    }
				})
				.catch(() => {
					this.$router.push('/');
				});
        }
    },
    computed: {
        completedLessons() {
            return this.course.lections.filter((lesson => lesson.progress && lesson.progress.id == 3));
        },
        uncompletedLessons() {
            return this.course.lections.filter((lesson => lesson.progress && lesson.progress.id != 3));
        }
    }
}
</script>

<style lang="scss" scoped>
.loader-container {
    min-height: calc(100vh - 208px);
    @media (max-width: 767px) {
        min-height: calc(100vh - 148px);
    }
}
</style>